<template>
  <div class="affix">
    <el-form :model="docItem" status-icon ref="ruleForm" label-width="180px" class="demo-ruleForm">
      <div class="title_name clearfix">
        <p v-if="docItem.name">{{docItem.name}}</p>
        <p v-else>{{docName}}</p>
      </div>
      <p class="doc-btn">
        <input @change="uploadName" :accept="accpt" style="display: none" type="file" :ref="attachmentId" name="attachmentId">
        <label class="upload" @click="uploadBtn($event)">
          <em class="el-icon-upload2"></em>
          <span>{{ name || '上传'}}</span>
        </label>
<!--        <label class="fileAdd" @click="addFile()">-->
<!--          <em class="el-icon-plus"></em>-->
<!--          <span>添加</span>-->
<!--        </label>-->
<!--        <label class="delete" @click="delMent(docItem)">-->
<!--          <em class="el-icon-delete"></em>-->
<!--          <span>删除</span>-->
<!--        </label>-->
        <label v-if="downBtn1" class="download">
          <em class="el-icon-download"></em>
          <span><a href='https://gcjs.hsztbzx.com:443/template/t_p_template/湖北省公共资源招标投标事前信用承诺书（范本）.docx' download>下载模板</a></span>
        </label>
        <b v-if="downBtn1" style="color: rgba(0, 0, 0, 0.45);font-weight: normal;font-size: 14px;"><i class="el-icon-warning-outline" style="margin: 0 5px 0 8px"></i>请先下载承诺书，签名盖章后上传承诺书扫描件！</b>
        <label v-if="downBtn2" class="download">
          <em class="el-icon-download"></em>
          <span><a href='https://gcjs.hsztbzx.com:443/template/t_p_template/法人授权委托书.doc' download>下载模板</a></span>
        </label>
        <b v-if="downBtn2" style="color: rgba(0, 0, 0, 0.45);font-weight: normal;font-size: 14px;"><i class="el-icon-warning-outline" style="margin: 0 5px 0 8px"></i>请先下载委托书，签名盖章后上传委托书扫描件！</b>
      </p>
    </el-form>
    <loadingTel v-if="loadingFlag" :textType="2" />
  </div>
</template>

<script>
  export default {
    // 文件上传成功时清空校验
    inject: ["uploadSuccess"],
    data() {
      return {
        loadingFlag:false,
        docName:'',
        attachmentId: 'attachment' + new Date().getTime(),
        showUpload: true,
        accpt:'',
        fileList:[],
      }
    },
    props: {
      index: {
        type: Number,
        required: true
      },
      docItem: {
        type: Object,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      fileLists:{
        type: Array,
      },
      downBtn1:{
        type: Boolean
      },
      downBtn2:{
        type: Boolean
      },
      attachmentParamList:{
        type: Array
      },
      name:{
        type: String
      },
      prop:{
        type: String
      },
    },
    mounted(){
       if(this.docItem.required == undefined){
          this.accpt = ".pdf,.PDF"
        }else{
           if(this.docItem.attributes){
               this.accpt = this.docItem.attributes.allows != undefined?this.docItem.attributes.allows:".pdf,.PDF";
           }
        }
        if(!!this.docItem.filePath){
          this.fileList.push(this.docItem.filePath);
          this.$emit('update:fileLists', this.fileList);
        }
    },
    methods: {
      uploadName() {
        var that = this;
        let AllupExt = this.getAccpet();
        let extName = this.$refs[that.attachmentId].files[0].name.substring(this.$refs[that.attachmentId].files[0].name.lastIndexOf('.')).toLowerCase();
        if (AllupExt.indexOf(extName) == '-1') {
          this.$alert('文件格式不正确，请重新上传', '警告', {
            confirmButtonText: '确定',
          })
          return;
        }
        this.docItem.fileType = this.index+1
        this.showUpload = false;
        let fd = new FormData();
        fd.append('file1', this.$refs[that.attachmentId].files[0]);
        fd.append('table', this.type);
        this.loadingFlag = true;
        this.$http.post('/sys/upload/uploadFile.do', fd).then(res => {
          if(res.data.code!='1'){
            this.loadingFlag = false;
            this.$alert('文件上传失败！', '警告', {
              confirmButtonText: '确定',
            });
            return;
          }
          if(!!this.prop){
            this.uploadSuccess(this.prop);
          }
          this.docName = res.data.data.name;
          this.docItem.filePath = res.data.data.filepath;
          this.docItem.name = res.data.data.name;
          // this.$refs[this.attachmentId].value = '';
          this.fileList.push(res.data.data.filepath);
          this.$emit('update:docItem', this.docItem);
          this.$emit('update:fileLists', this.fileList);
          this.loadingFlag = false;
          this.$notify({
            title: '文件上传',
            message: res.data.msg,
            position: 'bottom-right',
            type: 'success'
          })
        })
      },
      delMent(docItem) {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
         if (this.docItem.id !== ''){
            this.$http({
              method:'get',
              url:`/attachment/delattachmentbyid?id=${this.docItem.id}`,
            }).then(res => {
              if (res.data.code == 1){
                this.docName = '';
                this.fileList = [];
                this.$emit('fileList',this.fileList)
                this.deleteMes(docItem)
              }
            })
          }else {
             this.docName = '';
             this.deleteMes(docItem)
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },
      deleteMes(docItem){
           this.$message({
              type: 'success',
              message: '删除成功!'
            });
            if(this.docItem.required == undefined){
                this.$emit('delIndex', this.index);
            }else{
                let delment=this.docItem.attributes && this.docItem.attributes.delmethod  || '1';
                if(delment=='1' || delment == undefined){
                   this.$emit('delIndex', this.index);
                }else{
                  this.docItem.extendName= ''
                  this.docItem.filePath=''
                  this.docItem.extendName=''
                  this.docItem.id=''
                }
            }
            this.showUpload = true
      },
      uploadBtn(e) {
        this.$refs[this.attachmentId].click();
      },
      getAccpet(){
        if(this.docItem.required == undefined){
          this.accpt=".pdf,.PDF"
          var str= this.accpt
        }else{
          if(this.docItem.attributes && this.docItem.attributes.allows != undefined){
            var str=this.docItem.attributes.allows;
          }else{
            var str= ".pdf,.PDF"
          }
        }
        let reg=new RegExp(',','g')//g代表全部
        return str.replace(reg,"|");
      },
      addFile(){
        this.attachmentParamList.push({//附件列表
          Id: "",
          citeId: "",
          name: "",
          fileType: 1,
          filePath: "",
          required: false,
          attributes: {
            attname: "",
            delmethod: "2",
            allows: '.pdf,.PDF'
          }
        })
        this.$emit('upload:attachmentParamList',this.attachmentParamList);
      },
    },
    watch:{
      docItem(val){
        this.$emit('update:docItem',val)
      }
    }
  }
</script>

<style scoped>
  em{

  }
  .title_name{
    width: 330px;
  }
  .title_name p{
    width: 100%;
    height: 30px;
    line-height: 26px;
  }
   .color_inner{
    margin-right: 10px;
    color: red;
  }
  .download{
    margin: 0 0 0 10px;
  }
  .fileAdd{
    margin: 0 10px;
  }
</style>
